import React, { useContext, useEffect, useState } from 'react';
import { Box } from '@mui/material';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import MypageCompleteCard from '../../../uiParts/card/MypageCompleteCard';
import CustomSnackbar from '../../../uiParts/form/CustomSnackbar';
import SideBar from '../../../uiParts/menu/SideBar';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../../../../contexts/auth';
import { useAuthRedirect } from '../../../../hooks/useAuthRedirect';
import MetaTitle from '../../../utils/MetaTitle';
import { isOperatorStaff } from '../../../../utils/permission';
import { usePageLayout } from '../../../../hooks/usePageLayout';

interface LocationState {
  fromCompanyInvite?: boolean;
}

const CompanyInviteComplete: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState<boolean>(false);
  const { user, isLoading } = useContext(AuthContext);
  const navigate = useNavigate();
  // 未認証ならログイン画面へ退避する（元URLは ?redirect= で引き継ぐ。#3203）
  useAuthRedirect();
  const location = useLocation();
  const state = location.state as LocationState | null;
  const isValidAccess = Boolean(state?.fromCompanyInvite);
  const { sideBarCollapsed, toggleSidebar, styles: layoutStyles } = usePageLayout();

  useEffect(() => {
    const handlePopState = (): void => {
      setSnackbarOpen(true);
      window.history.pushState(null, '', window.location.href);
    };

    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    if (isLoading) return;
    if (user === null) {
      return;
    }
    if (!isOperatorStaff(user.role)) {
      navigate('/home');
      return;
    }

    if (!isValidAccess) {
      navigate('/admin/company');
    }
  }, [user, isLoading, navigate, isValidAccess]);

  if (!isValidAccess) {
    return null;
  }

  return (
    <Box sx={layoutStyles.pageWrapper}>
      <MetaTitle />
      <Box sx={[layoutStyles.sidebar, sideBarCollapsed && layoutStyles.sidebarCollapsed]}>
        <SideBar collapsed={sideBarCollapsed} onToggle={toggleSidebar} />
      </Box>
      <Box
        sx={[
          layoutStyles.pageContent,
          sideBarCollapsed && layoutStyles.pageContentCollapsed,
          layoutStyles.pageContentNoFooter,
          layoutStyles.fullHeightContent,
          {
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
      >
        <MypageCompleteCard
          IconComponent={MailOutlineIcon}
          titleText={'入力されたメールアドレスに\n招待メールを送信しました'}
          isMessageCenter
          messageText={
            'まだ会員情報登録は完了していません。\n招待先が会員情報登録を完了すると、企業が有効になります。\n有効期限を過ぎた場合は、再度招待を行ってください。'
          }
          buttonText="企業一覧へ"
          targetPath="/admin/company"
        />
      </Box>
      <CustomSnackbar
        open={snackbarOpen}
        onClose={(): void => setSnackbarOpen(false)}
        text=""
        infoText="前のページに戻れません。"
      />
    </Box>
  );
};

export default CompanyInviteComplete;
